module.exports = __webpack_public_path__ + "img/y-64.de124e6f.png";